import { Component, OnInit } from '@angular/core';
import {NewsService} from "../../services/news.service";
import { ActivatedRoute } from "@angular/router";
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.css']
})
export class NoticiaComponent implements OnInit {

  noticias: any = [];
  noticia: any = [{ imagen: '', titulo: '', texto: ''}];
  documentos: any = [];
  domain: string;
  url:string;
  constructor(private route: ActivatedRoute, private news: NewsService, private titleService: Title, private metaService: Meta) {
    this.route.params.subscribe( async params => {
      await this.getNew(params.id);
      console.log("11111111111", this.noticia);
      this.metaService.updateTag({ property: 'og:type', content: 'article' });      
      this.metaService.updateTag({ property: 'og:title', content: 'TITULOOOOOOOOOOO| MIN-MPD ' });
      this.metaService.updateTag({ property: 'og:description', content: "Ministerio de Planificación del Desarrollo" });
      this.metaService.updateTag({ property: 'og:image', content: 'http://www.planificacion.gob.bo/assets/BMH.jpg' });
      this.metaService.updateTag({ property: 'og:url', content: 'http://www.planificacion.gob.bo/noticia/prueba' });
    });

  }

  ngOnInit() {
    console.log("222222222222222");
    
    // this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    // this.metaService.updateTag({ name: 'twitter:site', content: '@minplanifica' });
    // this.metaService.updateTag({ name: 'twitter:title', content: this.noticia[0].titulo + '| MIN-MPD ' });
    // this.metaService.updateTag({ name: 'twitter:description', content: "Ministerio de Planificación del Desarrollo" });
    // this.metaService.updateTag({ name: 'twitter:image', content: 'http://www.planificacion.gob.bo/' + this.noticia[0].imagen });
      
    // this.metaService.updateTag({ property: 'og:type', content: 'article' });      
    // this.metaService.updateTag({ property: 'og:title', content: this.noticia[0].titulo + '| MIN-MPD ' });
    // this.metaService.updateTag({ property: 'og:description', content: "Ministerio de Planificación del Desarrollo" });
    // this.metaService.updateTag({ property: 'og:image', content: 'http://www.planificacion.gob.bo/' + this.noticia[0].imagen });
    // this.metaService.updateTag({ property: 'og:url', content: 'http://www.planificacion.gob.bo/noticia/' + this.noticia[0].id });
   
    
    this.news.getNews().subscribe(response => {
        //this.noticias= response[0];
        this.documentos = response[1];
        console.log('=>', this.documentos);
        /*this.documentos.forEach((item, index) => {
          this.dg1.push({id:item.id,titulo:item.titulo,imagen:item.imagen});
        });*/
        console.log('DOCS', this.documentos);
      
        console.log("popopo", this.noticia);

      // this.titleService.setTitle(this.noticia[0].titulo);
        // this.metaService.addTags([
        //   // { property: 'fb:app_id', content: "215197908804" },
        //   { property: 'og:type', content: "website" },
        //   { property: 'og:url', content: 'http://www.planificacion.gob.bo/noticia/' + this.noticia[0].id },
        //   { property: 'og:title', content: this.noticia[0].titulo + '| MIN-MPD '},
        //   { property: 'og:image', content: 'http://www.planificacion.gob.bo/' + this.noticia[0].imagen},
        //   { property: 'og:description', content: "Ministerio de Planificación del Desarrollo" },
        //   { property: 'twitter:card', content: "summary_large_image" },
        //   { property: 'twitter:site', content: "@minplanifica" },
        //   { property: 'twitter:title', content: this.noticia[0].titulo + '| MIN-MPD ' },
        //   { property: 'twitter:image', content: 'http://www.planificacion.gob.bo/' + this.noticia[0].imagen },
        //   { property: 'twitter:description', content: "Ministerio de Planificación del Desarrollo" },
        //   { property: 'twitter:url', content: 'http://www.planificacion.gob.bo/noticia/' + this.noticia[0].id }          
        // ]);
        /*setTimeout(()=>{
          this.test();
          this.show='block';

        },500);*/


      },
      error => {
        console.log(<any>error);
      });
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
        
  }
  private getNew(id){
    this.news.getNew(id).subscribe(response => {


      this.noticia=response[0];
      this.noticias=response[1];
      console.log('NOTICIA',this.noticia);
      this.url = 'libraries/pdf.php?noticia=' + btoa(id) + '&related=PLANIFICACION';      
        //this.test();
      this.metaService.updateTag({ property: 'og:type', content: 'article' });      
      this.metaService.updateTag({ property: 'og:title', content: 'TITULOOOOOOOOOOO| MIN-MPD ' });
      this.metaService.updateTag({ property: 'og:description', content: "Ministerio de Planificación del Desarrollo" });
      this.metaService.updateTag({ property: 'og:image', content: 'http://www.planificacion.gob.bo/assets/BMH.jpg' });
      this.metaService.updateTag({ property: 'og:url', content: 'http://www.planificacion.gob.bo/noticia/prueba' });

    },
    error => {
      console.log(<any>error);
    });
    
      
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/noticia/noticia.component.ts